// 剣舞の床技「裾払い」の予備動作 (2026-10-21・配布版の連撃の絵 v6 と一緒に使う)。
// 作者の答え (10-21 検収パック kensyu-blade-dancer-hem-1021 J-2)「a 沈む礼」= a を配布版の既定にした。
//   比べ: ?bladeHemWindup=b|c、前の予告 (円舞の構えから入る) は ?bladeHemWindup=now。
//
// 作者の答え (10-20): 判定は「気づきにくいけど、あとはボスに固有のモーションをつければわかるとは思います。」
//   今の予告は円舞連斬と同じ構え (waltz_ready) から入るので、構えを見た時点では裾払いと分からない。
//   3案とも、予告の頭から円舞の構えを使わず、低い・広い形で始める = 「下を払う技」と最初の1コマで読める。
//   絵は手持ちの2枚 (hem_rise = 低く構えて裾が広がった絵・hem_sweep = 床すれすれで払う絵) だけ。動きは手続き (位置・拡縮・傾き)。
//   案が決まったら、その形の絵を Codex に描かせて差し替える (合否は Opus)。
// 時間 (予告 700ms・当たり・戻り) と当たりは attacks.ts のまま。描くだけ。
//   a 沈む礼: 立ち姿から裾を広げてゆっくり沈み、低い所で溜める (フィギュアの深いお辞儀)。
//   b その場で回る: 低く構えたまま2回まわって加速し、床へ落ちる (DS3 冷たい谷の踊り子の回転の入り)。
//   c 刃を引く: 最初から床すれすれの払いの形を取り、後ろへ引きしぼってから前へ払う (弓を引く形)。
import { BOSS_ATTACK_TIMELINES, type BossAttackTimeline } from './boss_pose_timeline'

const BOSS_ID = 'blade-dancer'
export type BladeHemWindup = 'a' | 'b' | 'c'

// 当たりから後ろ (払い → 起き上がり → 立ち姿) は今の流れと同じ。
const AFTER: BossAttackTimeline = [
  { phase: 'active', at: 0, image: 'hem_sweep', hold: true, tag: 'contact' },
  { phase: 'recovery', at: 0, image: 'hem_sweep', hold: true, tag: 'followThrough' },
  { phase: 'recovery', at: 0.35, image: 'hem_rise', hold: true, tag: 'recover', ease: 'step' },
  { phase: 'recovery', at: 0.7, image: 'idle', hold: true, scale: { y: 0.82 }, offset: { x: 15 }, ease: 'easeOut' },
  { phase: 'recovery', at: 0.95, image: 'idle', hold: true },
]

export const BLADE_HEM_WINDUPS: Record<BladeHemWindup, BossAttackTimeline> = {
  a: [
    { phase: 'telegraph', at: 0, image: 'idle', hold: true, ease: 'easeIn' },
    { phase: 'telegraph', at: 0.1, image: 'idle', hold: true, scale: { x: 1.03, y: 0.9 }, ease: 'step' },
    { phase: 'telegraph', at: 0.12, image: 'hem_rise', hold: true, tag: 'anticipation', ease: 'easeOut' },
    { phase: 'telegraph', at: 0.45, image: 'hem_rise', hold: true, scale: { x: 1.08, y: 0.86 }, rot: -3, ease: 'easeInOut' },
    { phase: 'telegraph', at: 0.85, image: 'hem_rise', hold: true, scale: { x: 1.1, y: 0.8 }, rot: -4, offset: { x: -6 }, ease: 'easeIn' },
    { phase: 'telegraph', at: 0.97, image: 'hem_rise', hold: true, scale: { x: 1.1, y: 0.78 }, rot: 2, offset: { x: 4 }, ease: 'step' },
    ...AFTER,
  ],
  // 拡縮の x を 1 → -1 → 1 と通すと、絵が細くなって裏返る = その場で回って見える。半回転は 150ms → 110ms → 80ms と速める。
  b: [
    { phase: 'telegraph', at: 0, image: 'hem_rise', hold: true, tag: 'anticipation', scale: { y: 0.94 }, ease: 'easeInOut' },
    { phase: 'telegraph', at: 0.1, image: 'hem_rise', hold: true, scale: { x: 1, y: 0.92 }, ease: 'easeInOut' },
    { phase: 'telegraph', at: 0.31, image: 'hem_rise', hold: true, scale: { x: -1, y: 0.9 }, ease: 'easeInOut' },
    { phase: 'telegraph', at: 0.47, image: 'hem_rise', hold: true, scale: { x: 1, y: 0.88 }, ease: 'easeInOut' },
    { phase: 'telegraph', at: 0.6, image: 'hem_rise', hold: true, scale: { x: -1, y: 0.86 }, ease: 'easeInOut' },
    { phase: 'telegraph', at: 0.71, image: 'hem_rise', hold: true, scale: { x: 1, y: 0.84 }, ease: 'linear' },
    { phase: 'telegraph', at: 0.8, image: 'hem_rise', hold: true, scale: { x: -1, y: 0.82 }, ease: 'linear' },
    { phase: 'telegraph', at: 0.88, image: 'hem_rise', hold: true, scale: { x: 1, y: 0.8 }, ease: 'step' },
    { phase: 'telegraph', at: 0.93, image: 'hem_sweep', hold: true, scale: { x: 0.94, y: 1.04 }, ease: 'easeOut' },
    ...AFTER,
  ],
  c: [
    { phase: 'telegraph', at: 0, image: 'hem_rise', hold: true, scale: { y: 0.92 }, ease: 'step' },
    { phase: 'telegraph', at: 0.08, image: 'hem_sweep', hold: true, tag: 'anticipation', scale: { x: 0.96, y: 1.06 }, ease: 'easeOut' },
    { phase: 'telegraph', at: 0.35, image: 'hem_sweep', hold: true, offset: { x: -18 }, rot: -5, scale: { x: 1.02, y: 0.98 }, ease: 'easeInOut' },
    { phase: 'telegraph', at: 0.82, image: 'hem_sweep', hold: true, offset: { x: -26 }, rot: -7, scale: { x: 1.04, y: 0.95 }, ease: 'easeIn' },
    { phase: 'telegraph', at: 0.97, image: 'hem_sweep', hold: true, offset: { x: -10 }, rot: 2, ease: 'step' },
    ...AFTER,
  ],
}

/** URL の値を読む。指定なしは配布版の既定 a、'now' は前の予告のまま (null)。 */
export function parseBladeHemWindup(v: string | null): BladeHemWindup | null {
  if (v === 'now') return null
  return v === 'b' || v === 'c' ? v : 'a'
}

/** main.ts が技の絵の比較版 (?bladeMotion= / ?bladeMoves=1) を選んだ後に呼ぶ。技の絵が出ていない時は何もしない。 */
export function useBladeHemWindup(v: BladeHemWindup | null): void {
  const map = BOSS_ATTACK_TIMELINES[BOSS_ID]
  if (!v || !map) return
  BOSS_ATTACK_TIMELINES[BOSS_ID] = { ...map, hemSweep: BLADE_HEM_WINDUPS[v] }
}
